import { InjectionToken } from '@angular/core';
export type AccordionStyling = 'menu' | 'faqs';

export const SS_ACCORDION_STYLING = new InjectionToken<AccordionStyling>(
  'accordion-styling'
);
